'use client';

import SubjectTabs from '../generic/SubjectTabs';
import ChapterAnalysisTable from './ChapterAnalysisTable';
import { useState, useEffect } from 'react';
import TableLoader from '../generic/TableLoader';
import TableHeader from '../../components/generic/TableHeader';
import { PercentIcon } from '@phosphor-icons/react';
import NoData from '../generic/NoData';

const ChapterAnalysisContent = ({ data, loading, error, packId, testId, onResetFilters }) => {
  const [activeSubject, setActiveSubject] = useState(null);
  const [showPercentage, setShowPercentage] = useState(false);
  const [subjects, setSubjects] = useState([]);

  const onTogglePercentage = () => {
    setShowPercentage(!showPercentage);
  };

  // Extract and set subjects from data
  useEffect(() => {
    if (data && data.length > 0) {
      const extractedSubjects = data.map((subject) => ({
        _id: subject.subjectMeta._id,
        title: subject.subjectMeta.title,
        icon: subject.subjectMeta.icon,
        color: subject.subjectMeta.color,
        gradient: subject.subjectMeta.gradient,
        gradientDark: subject.subjectMeta.gradientDark,
        shortName: subject.subjectMeta.shortName,
      }));

      setSubjects(extractedSubjects);

      // Set initial active subject if not already set
      if (!activeSubject) {
        setActiveSubject(extractedSubjects[0]?._id);
      }
    }
  }, [data, activeSubject]);

  const findCurrentSubject = () => {
    return data?.find((s) => s?.subjectMeta?._id === activeSubject);
  };

  const subjectData = findCurrentSubject();

  return (
    <div>
      <div className="border border-[var(--q3-stroke-light)] rounded-b-lg rounded-t-lg">
        <TableHeader
          headerTitle="Analysis"
          headerSwitch={
            <span className="flex items-center gap-1">
              <PercentIcon size={16} weight="bold" />
              Show Percentage
            </span>
          }
          headerSwitchCase={showPercentage}
          headerSwitchHandler={onTogglePercentage}
          showBottomBorder={false}
        >
          <SubjectTabs
            activeSubject={activeSubject}
            onSubjectChange={setActiveSubject}
            showOverallTab={false}
            subjects={subjects}
          />

          <TableLoader loading={loading}>
            {error ? (
              <div className="text-red-500">Error loading data: {error.message}</div>
            ) : !subjectData ? (
              <NoData onResetAll={onResetFilters} />
            ) : (
              <ChapterAnalysisTable
                data={subjectData?.chapters}
                showPercentage={showPercentage}
                packId={packId}
                testId={testId}
                onResetFilters={onResetFilters}
              />
            )}
          </TableLoader>
        </TableHeader>
      </div>
    </div>
  );
};

export default ChapterAnalysisContent;
